import { media, styled, ButtonPrimaryTextOnly } from '@creditas-ui/react';

const Button = styled(ButtonPrimaryTextOnly)`
  margin-bottom: 56px;
  margin-top: 24px;

  ${media.up('5xl')} {
    margin-bottom: 0;
  }
`;

export { Button };
